import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

function CarriersDescription({ capacity, length, year, lang }) {
  return (
    <>
      {capacity && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en'
              ? `Capacity (MCM/year)`
              : `السعة (مليون م٣ في السنة)`}
          </div>
          <div className="value">
            {capacity}
            <span className="unit">{lang === 'en' ? `` : ``}</span>
          </div>
        </ResourceDetailsBlock>
      )}
      {length && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en' ? 'Length (km)' : 'الطول (كم)'}
          </div>
          <div className="value">{length}</div>
        </ResourceDetailsBlock>
      )}
      {year && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en' ? 'Year of operation' : 'سنة التشغيل'}
          </div>
          <div className="value">{year}</div>
        </ResourceDetailsBlock>
      )}
    </>
  )
}

CarriersDescription.propTypes = {
  id: PropTypes.string,
  capacity: PropTypes.string,
  length: PropTypes.string,
  year: PropTypes.string,
  lang: PropTypes.string
}

export default CarriersDescription
